export type AwsMetadataQueryParams = {
  domain?: string
  teamId: string
  mode?: string
}

export const awsMetadataQueryKeys = {
  getLambdas: (params: Omit<AwsMetadataQueryParams, 'mode'>) =>
    ['aws/metadata/lambdas', params] as const,
  getAutoscalingGroupsMetadata: (params: AwsMetadataQueryParams) =>
    ['aws/metadata/autoscaling-groups', params] as const,
  getIamRoleMetadata: (teamId: string) =>
    ['aws/metadata/iam-role', { teamId }] as const,
  getLoadBalancersMetadata: (params: AwsMetadataQueryParams) =>
    ['aws/metadata/load-balancers', params] as const
}
